import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import { DiscountRateResponse } from '../interfaces/reserve-add.model';

/**
 * 檢查相關資料服務
 */
@Injectable({
  providedIn: 'root',
})
export class AppointmentDiscountRateService {
  // axiosHttpService: AxiosHttpService = inject(AxiosHttpService);
  http: HttpClient = inject(HttpClient);

  /**
   * 查詢活動折扣率
   * @param orgNo 據點代碼
   */
  getDiscountRates(
    orgNo: string
  ): Observable<ApiResponse<DiscountRateResponse>> {
    return this.http.get<ApiResponse<DiscountRateResponse>>(
      API_ENDPOINTS.DISCOUNTRATES,
      { params: { orgNo } }
    );
  }
}
